import styles from './Keypad.module.css'

export const CLEAR_KEY = 'پاک'
export const BACKSPACE_KEY = '⌫'

/** The artboard's own order: ۱-۹, then «پاک», ۰, «⌫». */
const KEYS = ['۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹', CLEAR_KEY, '۰', BACKSPACE_KEY] as const

interface KeypadProps {
  onPress: (key: string) => void
}

export function Keypad({ onPress }: KeypadProps) {
  return (
    <div className={styles.pad}>
      {KEYS.map((key) => (
        <button
          type="button"
          key={key}
          className={`${styles.key} ${key === CLEAR_KEY || key === BACKSPACE_KEY ? styles.wordKey : ''}`}
          onClick={() => onPress(key)}
          aria-label={key === BACKSPACE_KEY ? 'حذف رقم آخر' : key === CLEAR_KEY ? 'پاک کردن' : key}
        >
          {key}
        </button>
      ))}
    </div>
  )
}
